import services from '@/services/ascentiaServiceIndex'
import { LOOKUP_CONSTS as LC, FLIGHT_PHASE_CONSTS as FP } from '../consts'
import { FLIGHTS, DAYS_BACK } from '@/utilities/appConsts'
import _ from 'lodash'

const state = {
  aircraft: [],
  airlines: [],
  analytics: [],
  ataChapters: [],
  ataSubchapters: [],
  components: {},
  features: [],
  flightPhases: [],
  masterModelsLoading: false,
  aircraftsLoading: false,
  masterModels: [],
  airlineMasterModelAgreement: [],
  operators: [],
  parameters: {},
  parametersWithId: [],
  paras: [],
  roles: [],
  systems: {},
  models: [],
}

function tryParseIntToStringIfNan(value) {
  if (isNaN(value)) {
    return value
  }

  return Number(value)
}

const getters = {
  mappedUserMasterModels: state => {
    if (state.masterModels) {
      return state.masterModels.map(item => {
        return {
          airlineId: item.airlineId,
          masterModelId: item.value,
          text: item.text,
          value: item.value,
        }
      })
    }
    return []
  },
  mappedUserMasterModelsWithAirlines(state, getters, rootState, rootGetters) {
    const airlinesData = rootGetters['user/mappedUserAirlines']
    if (state.masterModels.length > 0 && airlinesData.length > 0) {
      const groupedByMasterModelId = _.groupBy(
        state.masterModels,
        'masterModelId',
      )
      const items = Object.keys(groupedByMasterModelId).map((key, index) => {
        const values = Object.values(groupedByMasterModelId)[index]
        const text = values.length > 0 ? values[0].text : ''
        return {
          masterModelId: Number(key),
          text,
          value: Number(key),
          items: airlinesData
            .filter(
              item =>
                values.findIndex(
                  airline => airline.airlineId === item.airlineId,
                ) > -1,
            )
            .sort((a, b) =>
              a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
            ),
        }
      })

      return items.sort((a, b) =>
        a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1,
      )
    }

    return []
  },
  mappedLuMasterModels: (state, getters, rootState, rootGetters) => {
    if (state.masterModels) {
      const selections = rootGetters['globalFilter/selections']
      const masterModels = getters.mappedLuMasterModelsAll
      return masterModels.filter(
        item =>
          selections.length === 0 ||
          selections.filter(
            selection =>
              selection.airlineId === item.airlineId &&
              selection.masterModelId === item.masterModelId,
          ).length > 0,
      )
    }
    return []
  },
  mappedLuMasterModelsAll: state => {
    if (state.masterModels) {
      return state.masterModels.map(item => {
        return {
          airlineId: item.airlineId,
          masterModelId: item.value,
          text: item.text,
          value: item.value,
        }
      })
    }
    return []
  },
  mappedAircraft: state => {
    if (state.aircraft) {
      return state.aircraft.map(item => {
        return {
          value: item.id,
          text: item.name,
          airlineId: item.airlineId,
          airlineTierTypeId: item.airlineTierTypeId,
          masterModelId: item.masterModelId,
        }
      })
    }

    return []
  },
  mappedLuTails: (state, getters, rootState, rootGetters) => {
    if (state.aircraft) {
      const mappedUserAirlines = rootGetters['user/mappedUserAirlines']
      const selections = rootGetters['globalFilter/selections']

      return getters.mappedAircraft
        .filter(
          item =>
            selections.length === 0 ||
            selections.filter(
              selection =>
                selection.airlineId === item.airlineId &&
                selection.masterModelId === item.masterModelId,
            ).length > 0,
        )
        .map(item => {
          const [airline] = mappedUserAirlines.filter(
            airline => airline.value === item.airlineId,
          )

          return {
            airlineId: item.airlineId,
            masterModelId: item.masterModelId,
            text: item.text,
            value: item.value,
            airlineTierTypeId: item.airlineTierTypeId,
            airlineAgreementTypes: airline.phmAgreementTypes,
            search: airline
              ? `${item.text}${airline.icaoCode}${airline.airlineName}`
              : item.text,
          }
        })
    }

    return []
  },
  mappedLuTailsAll: (state, getters, rootState, rootGetters) => {
    if (state.aircraft) {
      const mappedUserAirlines = rootGetters['user/mappedUserAirlines']
      return getters.mappedAircraft.map(item => {
        const [airline] = mappedUserAirlines.filter(
          airline => airline.value === item.airlineId,
        )

        return {
          airlineId: item.airlineId,
          masterModelId: item.masterModelId,
          text: item.text,
          value: item.value,
          airlineTierTypeId: item.airlineTierTypeId,
          search: airline
            ? `${item.text}${airline.icaoCode}${airline.airlineName}`
            : item.text,
        }
      })
    }

    return []
  },
  mappedLuFeatures: state => {
    if (state.features) {
      return state.features.map(item => {
        return {
          ...item,
          analyticId: item.analyticId,
          featureId: item.id,
          text: item.name,
          value: item.id,
        }
      })
    }
    return []
  },
  mappedLuAnalytics: state => {
    if (state.analytics) {
      return state.analytics.map(item => {
        return {
          ...item,
          analyticId: item.id,
          componentId: item.componentId,
          text: item.name,
          value: item.id,
        }
      })
    }
    return []
  },
  mappedLuFlightPhases: state => {
    const uniqueMasterModels = [
      ...new Set(
        state.flightPhases.map(flightPhaseObj => flightPhaseObj.masterModelId),
      ),
    ]
    const flightPhaseAll = uniqueMasterModels.map(masterModel => {
      return {
        text: 'All',
        value: 0,
        masterModelId: masterModel,
      }
    })
    const flightPhases = state.flightPhases.map(flightPhaseObj => {
      return {
        text: flightPhaseObj.longName,
        value: flightPhaseObj.dataMapping,
        masterModelId: flightPhaseObj.masterModelId,
      }
    })
    return flightPhaseAll.concat(flightPhases).sort((a, b) => a.value - b.value)
  },
  mappedLuFlights: () => {
    return FLIGHTS.map(item => {
      return {
        text: item.name,
        value: item.id,
      }
    })
  },
  mappedLuDaysBack: () => {
    return DAYS_BACK.map(item => {
      return {
        text: item.name,
        value: item.id,
      }
    })
  },
  gafTails: (state, getters, rootState, rootGetters) => {
    return state.aircraft.filter(item => {
      // Global Airline Filter
      if (rootGetters['globalFilter/showAllAirlines']) {
        return true
      } else {
        return (
          rootGetters['globalFilter/airlineIdsSelected'].indexOf(
            item.airlineId,
          ) > -1
        )
      }
    })
  },
  mappedLuSystemsByAirline: (state, getters, rootState, rootGetters) => {
    if (state.systems) {
      const items = []
      Object.keys(state.systems).forEach((item, index) => {
        const values = Object.values(state.systems)[index]
        const airlineId = tryParseIntToStringIfNan(item)
        values.forEach(item2 => {
          const item = {
            airlineId,
            ...item2,
          }
          items.push(item)
        })
      })

      const selections = rootGetters['globalFilter/selections']

      return items
        .filter(
          item =>
            selections.length === 0 ||
            selections.filter(
              selection =>
                selection.airlineId === item.airlineId &&
                selection.masterModelId === item.masterModelId,
            ).length > 0,
        )
        .map(item => {
          return {
            systemId: item.value,
            airlineId: tryParseIntToStringIfNan(item.airlineId),
            masterModelId: item.masterModelId,
            text: item.text,
            value: item.value,
          }
        })
    }

    return []
  },
  mappedLuSystemsByAirlineAll: state => {
    if (state.systems) {
      const items = []
      Object.keys(state.systems).forEach((item, index) => {
        const values = Object.values(state.systems)[index]
        const airlineId = tryParseIntToStringIfNan(item)
        values.forEach(item2 => {
          const item = {
            airlineId,
            ...item2,
          }
          items.push(item)
        })
      })

      return items.map(item => {
        return {
          systemId: item.value,
          airlineId: tryParseIntToStringIfNan(item.airlineId),
          masterModelId: item.masterModelId,
          text: item.text,
          value: item.value,
        }
      })
    }

    return []
  },
  mappedLuComponentsByAirline: (state, getters, rootState, rootGetters) => {
    if (state.components) {
      const items = []
      const systems = getters.mappedLuSystemsByAirline
      Object.keys(state.components).forEach((item, index) => {
        const values = Object.values(state.components)[index]
        const airlineId = tryParseIntToStringIfNan(item)
        values.forEach(component => {
          const [first] = systems.filter(
            system =>
              system.airlineId === tryParseIntToStringIfNan(airlineId) &&
              system.value === component.systemId,
          )
          if (first) {
            const item = {
              airlineId,
              ...component,
              masterModelId: first.masterModelId,
            }
            items.push(item)
          }
        })
      })

      const selections = rootGetters['globalFilter/selections']

      return items
        .filter(
          item =>
            selections.length === 0 ||
            selections.filter(
              selection =>
                selection.airlineId === item.airlineId &&
                selection.masterModelId === item.masterModelId,
            ).length > 0,
        )
        .map(item => {
          return {
            systemId: item.systemId,
            systemName: item.systemName,
            airlineId: tryParseIntToStringIfNan(item.airlineId),
            componentId: item.value,
            masterModelId: item.masterModelId,
            text: item.text,
            value: item.value,
          }
        })
    }

    return []
  },
  mappedLuComponentsByAirlineAll: (state, getters) => {
    if (state.components) {
      const items = []
      const systems = getters.mappedLuSystemsByAirline
      Object.keys(state.components).forEach((item, index) => {
        const values = Object.values(state.components)[index]
        const airlineId = tryParseIntToStringIfNan(item)
        values.forEach(component => {
          const [first] = systems.filter(
            system =>
              system.airlineId === tryParseIntToStringIfNan(airlineId) &&
              system.value === component.systemId,
          )
          if (first) {
            const item = {
              airlineId,
              ...component,
              masterModelId: first.masterModelId,
            }
            items.push(item)
          }
        })
      })

      return items.map(item => {
        return {
          systemId: item.systemId,
          airlineId: tryParseIntToStringIfNan(item.airlineId),
          componentId: item.value,
          masterModelId: item.masterModelId,
          text: item.text,
          value: item.value,
        }
      })
    }

    return []
  },
  mappedLuParametersByAirline: (state, getters, rootState, rootGetters) => {
    if (state.parameters) {
      const items = []
      Object.keys(state.parameters).forEach((item, index) => {
        const values = Object.values(state.parameters)[index]
        const airlineId = tryParseIntToStringIfNan(item)
        values.forEach(item2 => {
          const item = {
            airlineId,
            ...item2,
          }
          items.push(item)
        })
      })

      const airlineIds = rootGetters['globalFilter/airlineIdsSelected']

      return items
        .filter(
          item =>
            airlineIds.length === 0 ||
            airlineIds.includes(tryParseIntToStringIfNan(item.airlineId)),
        )
        .map(item => {
          return {
            airlineId: tryParseIntToStringIfNan(item.airlineId),
            componentId: item.componentId,
            parameterId: item.value,
            text: item.text,
            value: item.value,
            eccnName: item.eccnName,
            eccnRank: item.eccnRank,
            hasStringKeys: item.hasStringKeys,
          }
        })
    }

    return []
  },
  mappedLuAtaChapters: state => {
    if (state.ataChapters) {
      return state.ataChapters.map(item => {
        return {
          ...item,
          ataChapterId: item.ataChapter,
          ataChapterDesc: item.description,
          text: item.ataChapter + ' - ' + item.description,
          value: item.ataChapter,
        }
      })
    }
    return []
  },
  mappedLuAtaChaptersWithZeroes: state => {
    if (state.ataChapters) {
      return state.ataChapters.map(item => {
        return {
          ...item,
          ataChapterId: item.ataChapter,
          ataChapterDesc: item.description,
          text:
            String(item.ataChapter).padStart(2, '0') + ' - ' + item.description,
          value: String(item.ataChapter).padStart(2, '0'),
        }
      })
    }
    return []
  },
  mappedLuAtaSubchapters: state => {
    if (state.ataSubchapters) {
      return state.ataSubchapters.map(item => {
        return {
          ...item,
          ataChapterId: item.ataChapter,
          ataSubchapterId: item.subChapter,
          ataSubchapterDesc: item.description,
          text: item.subChapter + ' - ' + item.description,
          value: item.subChapter,
        }
      })
    }
    return []
  },
  mappedUserModels: state => {
    if (state.models) {
      return state.models.map(item => {
        return {
          text: item.name,
          value: item.id,
          masterModelId: item.masterModelId,
        }
      })
    }
    return []
  },
  mappedLuParametersByAirlineAll: state => {
    if (state.parameters) {
      const items = []
      Object.keys(state.parameters).forEach((item, index) => {
        const values = Object.values(state.parameters)[index]
        const airlineId = tryParseIntToStringIfNan(item)
        values.forEach(item2 => {
          const item = {
            airlineId,
            ...item2,
          }
          items.push(item)
        })
      })

      return items.map(item => {
        return {
          airlineId: tryParseIntToStringIfNan(item.airlineId),
          componentId: item.componentId,
          parameterId: item.value,
          text: item.text,
          value: item.value,
          eccnName: item.eccnName,
          eccnRank: item.eccnRank,
          hasStringKeys: item.hasStringKeys,
        }
      })
    }

    return []
  },
  mappedDistinctAirlineWithMasterModelAgreementData:
    state => masterModelData => {
      const groupedTails = _.groupBy(state.aircraft, item => {
        return (
          item.airlineId +
          '--' +
          item.masterModelId +
          '--' +
          item.airlineTierTypeId
        )
      })
      const keys = Object.keys(groupedTails)
      const mappedAirlineMasterModelAgreementData = keys.map(key => {
        const airlineId = key.split('--')[0]
        const masterModelId = key.split('--')[1]
        const agreementType = key.split('--')[2]
        const agreementTypeId = tryParseIntToStringIfNan(agreementType)
        const [first] = masterModelData
          .filter(item => item.value === parseInt(masterModelId, 0))
          .map(item => {
            return {
              ...item,
              agreementTypeId,
            }
          })
        return {
          airlineId: tryParseIntToStringIfNan(airlineId),
          platformAgreementData: first,
        }
      })
      let mappedDistinctAirlineWithMasterModelAgreementData = []
      mappedAirlineMasterModelAgreementData.forEach(item => {
        var existing = mappedDistinctAirlineWithMasterModelAgreementData.find(
          item2 => {
            return item2.airlineId == item.airlineId
          },
        )
        if (existing) {
          var existingIndex =
            mappedDistinctAirlineWithMasterModelAgreementData.indexOf(existing)
          mappedDistinctAirlineWithMasterModelAgreementData[
            existingIndex
          ].platformAgreementData = mappedDistinctAirlineWithMasterModelAgreementData[
            existingIndex
          ].platformAgreementData.concat(item.platformAgreementData)
        } else {
          item.platformAgreementData = [item.platformAgreementData]
          mappedDistinctAirlineWithMasterModelAgreementData.push(item)
        }
      })
      return mappedDistinctAirlineWithMasterModelAgreementData
    },
  mappedAirlineMasterModelAgreement: state => {
    if (state.airlineMasterModelAgreement) {
      let val = []
      state.airlineMasterModelAgreement.forEach(m => {
        m.platformAgreementData.forEach(f => {
          const item = {
            agreementTypeId: f.agreementTypeId,
            text: f.text,
            value: f.value,
            airlineId: m.airlineId,
          }
          val.push(item)
        })
      })
      return val
    }
    return []
  },
}

const mutations = {
  [LC.UPDATE_AIRLINES]: (state, data) => (state.airlines = data),
  [LC.UPDATE_AIRLINES]: (state, data) => {
    state.airlines = data
  },
  [LC.UPDATE_AIRCRAFTS]: (state, data) => (state.aircraft = data),
  [LC.UPDATE_ANALYTICS]: (state, data) => (state.analytics = data),
  [LC.UPDATE_FEATURES]: (state, data) => (state.features = data),
  [LC.UPDATE_ROLES]: (state, data) => (state.roles = data),
  [LC.UPDATE_OPERATORS]: (state, data) => (state.operators = data),
  [LC.UPDATE_MASTER_MODELS]: (state, data) => (state.masterModels = data),
  [LC.UPDATE_AIRLINE_MASTERMODEL_AGREEMENT]: (state, data) =>
    (state.airlineMasterModelAgreement = data),
  [LC.UPDATE_SYSTEMS]: (state, data) => (state.systems = data),
  [LC.UPDATE_COMPONENTS]: (state, data) => (state.components = data),
  [LC.UPDATE_PARAMETERS]: (state, data) => (state.parameters = data),
  [LC.UPDATE_PARAMETERS_WITH_ID]: (state, data) =>
    (state.parametersWithId = data),
  [LC.UPDATE_FLIGHT_PHASES]: (state, data) => (state.flightPhases = data),
  [LC.UPDATE_ATA_CHAPTERS]: (state, data) => (state.ataChapters = data),
  [LC.UPDATE_ATA_SUBCHAPTERS]: (state, data) => (state.ataSubchapters = data),
  [LC.UPDATE_MODELS]: (state, data) => (state.models = data),
  [LC.UPDATE_PERMISSIONS]: (state, data) => (state.permissions = data),
  [LC.UPDATE_MASTER_MODELS_LOADING]: (state, data) =>
    (state.masterModelsLoading = data),
  [LC.UPDATE_AIRCRAFTS_LOADING]: (state, data) =>
    (state.aircraftsLoading = data),
}

const actions = {
  async [LC.GET_AIRCRAFTS]({ commit }) {
    try {
      commit(LC.UPDATE_AIRCRAFTS_LOADING, true)
      const response = await services.lookup.getData('tailData')
      commit(LC.UPDATE_AIRCRAFTS, response.data)
      commit(LC.UPDATE_AIRCRAFTS_LOADING, false)
    } catch (error) {
      console.log(`${[LC.GET_AIRCRAFTS]}: error ${error}`)
      commit(LC.UPDATE_AIRCRAFTS_LOADING, false)
    }
  },
  async [LC.GET_ANALYTICS]({ commit }) {
    const response = await services.lookup.getData('analytics')
    commit(LC.UPDATE_ANALYTICS, response.data)
  },
  async [LC.GET_FEATURES]({ commit }) {
    const response = await services.lookup.getData('features')
    commit(LC.UPDATE_FEATURES, response.data)
  },
  async [LC.GET_ROLES]({ commit }) {
    try {
      const response = await services.lookup.getData('rolesData')
      commit(LC.UPDATE_ROLES, response.data)
    } catch (error) {
      console.log(`${[LC.GET_ROLES]}: error ${error}`)
    }
  },
  async [LC.GET_PERMISSIONS]({ commit }) {
    try {
      const response = await services.lookup.getData('permissionsData')
      commit(LC.UPDATE_PERMISSIONS, response.data)
    } catch (error) {
      console.log(`${[LC.GET_PERMISSIONS]}: error ${error}`)
    }
  },
  async [LC.GET_MASTER_MODELS]({ commit, state, getters }) {
    try {
      // get master models lookup data
      commit(LC.UPDATE_MASTER_MODELS_LOADING, true)
      const mmResponse = await services.lookup.getData('masterModelData')
      const masterModelData = mmResponse.data.map(item => {
        return {
          value: item.id,
          text: item.name,
        }
      })
      // group tails data by airlineId and masterModelId
      const groupedTails = _.groupBy(state.aircraft, item => {
        return (
          item.airlineId +
          '--' +
          item.masterModelId +
          '--' +
          item.airlineTierTypeId
        )
      })
      const keys = Object.keys(groupedTails)

      // iterate through each airlineId/masterModel combination and add
      const mappedMasterModelData = keys.map(key => {
        const airlineId = key.split('--')[0]
        const masterModelId = key.split('--')[1]
        const [first] = masterModelData.filter(
          item => item.value === parseInt(masterModelId, 0),
        )

        return {
          masterModelId: parseInt(masterModelId, 0),
          airlineId: tryParseIntToStringIfNan(airlineId),
          text: first.text,
          value: first.value,
        }
      })

      commit(LC.UPDATE_MASTER_MODELS, mappedMasterModelData)

      let data = [
        ...getters.mappedDistinctAirlineWithMasterModelAgreementData(
          masterModelData,
        ),
      ]
      commit(LC.UPDATE_AIRLINE_MASTERMODEL_AGREEMENT, data)
      commit(LC.UPDATE_MASTER_MODELS_LOADING, false)
    } catch (error) {
      console.log(`${LC.GET_MASTER_MODELS}: error ${error}`)
      commit(LC.UPDATE_MASTER_MODELS_LOADING, false)
    }
  },
  async [LC.GET_SYSTEMS]({ commit }) {
    try {
      const response = await services.lookup.getData('systemData')
      const data = Object.keys(response.data).reduce((acc, alId) => {
        acc[alId] = response.data[alId].map(item => {
          return {
            value: item.id,
            text: item.name,
            masterModelId: item.masterModelId,
          }
        })
        return acc
      }, {})
      commit(LC.UPDATE_SYSTEMS, data)
    } catch (error) {
      console.log(`${LC.GET_SYSTEMS}: error ${error}`)
    }
  },
  async [LC.GET_COMPONENTS]({ commit }) {
    try {
      const response = await services.lookup.getData('componentData')
      const data = Object.keys(response.data).reduce((acc, alId) => {
        acc[alId] = response.data[alId].map(item => {
          return {
            value: item.id,
            text: item.name,
            systemId: item.systemId,
            systemName: item.systemName,
          }
        })
        return acc
      }, {})

      commit(LC.UPDATE_COMPONENTS, data)
    } catch (error) {
      console.log(`${LC.GET_COMPONENTS}: error ${error}`)
    }
  },
  async [LC.GET_PARAMETERS]({ commit }) {
    try {
      const response = await services.lookup.getData('parameterData')
      const data = Object.keys(response.data).reduce((acc, alId) => {
        acc[alId] = response.data[alId].map(item => {
          return {
            value: item.id,
            text: item.name,
            componentId: item.componentId,
            unit: item.unit,
            eccnName: item.eccnName,
            eccnRank: item.eccnRank,
            isAnalytic: item.analytic,
            hasStringKeys: item.hasStringKeys,
          }
        })
        return acc
      }, {})

      commit(LC.UPDATE_PARAMETERS, data)
    } catch (error) {
      console.log(`${LC.GET_PARAMETERS}: error ${error}`)
    }
  },
  async [FP.GET_FLIGHT_PHASES]({ commit }) {
    try {
      const response = await services.flightPhase.getData('flightPhaseData')
      commit(FP.UPDATE_FLIGHT_PHASES, response.data)
    } catch (error) {
      console.log(`${FP.GET_FLIGHT_PHASES}: error ${error}`)
    }
  },
  async [LC.GET_OPERATORS]({ commit }) {
    try {
      const response = await services.lookup.getData('operatorData')
      const data = response.data
      commit(LC.UPDATE_AIRLINES, data)
    } catch (error) {
      console.log(`${LC.GET_OPERATORS}: error ${error}`)
    }
  },
  async [LC.GET_ATA_CHAPTERS]({ commit }) {
    try {
      const response = await services.lookup.getData('ataChaptersData')
      const data = response.data
      commit(LC.UPDATE_ATA_CHAPTERS, data)
    } catch (error) {
      console.log(`${LC.GET_ATA_CHAPTERS}: error ${error}`)
    }
  },
  async [LC.GET_ATA_SUBCHAPTERS]({ commit }) {
    try {
      const response = await services.lookup.getData('ataSubchaptersData')
      const data = response.data
      commit(LC.UPDATE_ATA_SUBCHAPTERS, data)
    } catch (error) {
      console.log(`${LC.GET_ATA_SUBCHAPTERS}: error ${error}`)
    }
  },
  async [LC.GET_MODELS]({ commit }) {
    try {
      const response = await services.lookup.getData('modelData')
      const data = response.data
      commit(LC.UPDATE_MODELS, data)
    } catch (error) {
      console.log(`${LC.GET_MODELS}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
